import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import dynamic from 'next/dynamic';
import { useCallback } from 'react';

import { INSERT_MENTION_COMMAND } from 'components/TextEditor/Plugins/MentionPlugin';

import useModal from 'hooks/useModal';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import { useDomain } from 'providers/DomainProvider';
import { useUser } from 'providers/UserProvider';

import ToolButton from '../ToolButton';

const MentionModal = dynamic(() => import('./MentionModal'), {
  ssr: false,
});

const GA_EVENT_CATEGORY = 'mark_users_modal';

const Mention = () => {
  const [editor] = useLexicalComposerContext();
  const { domain, domainId } = useDomain();
  const { runCallbackIfLoggedIn } = useUser();
  const { showModal } = useModal();

  const onAddMention = useCallback(
    (userUsername) => {
      editor.dispatchCommand(INSERT_MENTION_COMMAND, userUsername);
    },
    [editor]
  );

  const onClick = () => {
    sendEvent({ action: 'show_modal', category: GA_EVENT_CATEGORY });
    runCallbackIfLoggedIn(showModal, MentionModal, {
      gaEventCategory: GA_EVENT_CATEGORY,
      domain,
      domainId,
      onAddMention,
    });
  };

  return (
    <ToolButton
      aria-label="Marcar algum membro do Promobit"
      iconName="at"
      tip={placeholder('tips.member')}
      onClick={onClick}
    />
  );
};

export default Mention;
